export var IntegrationType;
(function (IntegrationType) {
    IntegrationType[IntegrationType["ExternalService"] = 0] = "ExternalService";
    IntegrationType[IntegrationType["InternalService"] = 1] = "InternalService";
    IntegrationType[IntegrationType["UiOrForm"] = 2] = "UiOrForm";
    IntegrationType[IntegrationType["WebHook"] = 3] = "WebHook";
    IntegrationType[IntegrationType["None"] = 4] = "None";
})(IntegrationType || (IntegrationType = {}));
;
